import { SampleDocs, SampleMachine } from './SampleMachine';

import { SampleTypes } from '../Types';

const onSample: SampleTypes = {
  machine: SampleMachine,
  docs: SampleDocs,
  order: 1,
};

export default { onSample };
